export const NAME = 'campaignTemplates';

export const templateTypes = {
	LOAD: 'LOAD',
	SAVE: 'SAVE',
};
